import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const loanModule = {
  namespaced: true,
  state() {
    return {
      loandata: Object,
      selectedLoan: Object,
      loanEntitiesInfo: Array,
      loanType: Array,
      iceAPIResponse: Object,
      loanInput: Object,
      compareLoans: Object,
      iceProjectionModel: Object,
    };
  },
  mutations,
  actions,
  getters,
};

export default loanModule;
